module.exports = __webpack_public_path__ + "img/2.64f8fd6d.jpg";